import clsx from "clsx";

import { IconProps, RefreshIcon } from "../Icon";
import styles from "./index.module.css";

export const CircularProgress = ({ className, color, size }: IconProps) => (
  <RefreshIcon className={clsx(styles.base, className)} color={color} size={size} />
);
